"use client";
import Input from "../../../components/Input";

export const SystemTypes = [
  { value: "phone", text: "Phone" },
  { value: "email", text: "Email" },
  { value: "whatsapp", text: "WhatsApp" },
];

type Props= {
  register: any;
  errors: any;
}

const AddCountryModal = ({ register, errors }: Props) => {
  return (
    <div className="w-[655px] p-4 space-y-4">
      <div className="grid grid-cols-1 gap-4">
        <Input
          name="countryName"
          type="text"
          title="Country Name"
          placeholder="Saudi Arabia"
          register={register}
          error={errors.countryName}
          validation={{
            required: "Country is required",
          }}
        />

        <Input
          name="countryCode"
          type="text"
          title="Country Code"
          placeholder="SR"
          register={register}
          error={errors.countryCode}
          validation={{
            required: "CountryCode is required",
          }}
        />

        <Input
          name="currencyCode"
          type="text"
          title="Currency Code"
          placeholder="SAR"
          register={register}
          error={errors.currencyCode}
          validation={{
            required: "Currency Code is required",
          }}
        />

        <Input
          name="dialCode"
          type="number"
          title="Dial Code"
          placeholder="966"
          register={register}
          error={errors.dialCode}
          validation={{
            required: "Dial Code is required",
            pattern: {
              value: /^[0-9]+$/,
              message: "Dial Code must be numeric",
            },
          }}
        />

      </div>
    </div>
  );
};

export default AddCountryModal;
